import { CustomerService } from '@bufteam/cfacorp_customer-and-identity-services.bufbuild_es/cfa/d2c/frontend/customer/v1/customer_service_pb.js';
import { createClient } from '@connectrpc/connect';
import { createConnectTransport } from '@connectrpc/connect-web';
import { Observable } from 'rxjs';
import ooeConstants from '../constants';
import { mapGetCustomerResponseToGuestProfile } from '../schemas/mapGetCustomerToGuestProfile';
import handleConnectCall from '../util/handleConnectCall';
import handleErrors from '../util/handleErrors';
import { leaveBreadcrumb } from './bugsnag';

export function getGuestOAuth(idToken) {
  const baseUrl = ooeConstants.URL.PROFILE;
  const url = `${baseUrl}/users/3.0/session?token=${idToken}`;

  const bugsnagInfo = {
    errorClass: ooeConstants.BUGSNAG_ERRORCLASS_PROFILE,
    breadcrumb: 'Attempting to retrieve OAuth',
    context: 'Get Guest OAuth',
    info: {
      method: 'GET',
      baseUrl,
      url: `${url.substring(0, 96)}******`,
    },
  };

  leaveBreadcrumb(bugsnagInfo.context, bugsnagInfo);

  const request = fetch(url, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
    },
  }).then((response) => handleErrors(response, bugsnagInfo));

  return Observable.fromPromise(request);
}

export function getGuestProfile(apiKey) {
  const baseUrl = ooeConstants.URL.D2C_CONNECT;

  const bugsnagInfo = {
    errorClass: ooeConstants.BUGSNAG_ERRORCLASS_PROFILE,
    breadcrumb: 'Attempting to retrieve guest profile',
    context: 'Get Guest Profile',
    info: {
      method: 'POST',
      rpc: 'GetCustomer',
      baseUrl,
      apiKey: `******${apiKey?.slice?.(-6)}`,
    },
  };

  leaveBreadcrumb(bugsnagInfo.context, bugsnagInfo);

  const request = handleConnectCall(async () => {
    const transport = createConnectTransport({
      baseUrl,
      interceptors: [
        (next) => async (req) => {
          req.header.set('Authorization', `Bearer ${apiKey}`);
          return await next(req);
        },
      ],
    });
    const client = createClient(CustomerService, transport);
    const response = await client.getCustomer({});

    return mapGetCustomerResponseToGuestProfile(response);
  }, bugsnagInfo);

  return Observable.fromPromise(request);
}

export default {
  getGuestOAuth,
  getGuestProfile,
};
